import { useMutation, useQueryClient } from '@tanstack/react-query'

import { QUERY_KEYS } from '../../../lib/queryKeys'
import { updatePackageReq } from '../packageReqService'

export const useUpdatePackageReq = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: updatePackageReq,
    onSuccess: (_, { packageReqId, ...updateData }) => {
      queryClient.setQueriesData({ queryKey: [QUERY_KEYS.PACKAGE_REQUESTS], exact: false }, old => {
        const updatedData = {}
        Object.keys(old).forEach(key => {
          if (!old[key]) return
          updatedData[key] = old[key].map(item => (item.id === packageReqId ? { ...item, ...updateData } : item))
        })
        return updatedData
      })
    },
  })
}
